import React, { forwardRef, useMemo } from 'react';

import {
  Tag as BalanceTag,
  TagProps as BalanceTagProps,
} from '@reckon-web/tag';

import { WorkflowPaletteKey, workflowPaletteKeys } from '../../theme';

const defaultColor = workflowPaletteKeys[0];

export type TagProps = {
  color?: WorkflowPaletteKey;
} & Omit<BalanceTagProps, 'variant'>;

/** Reconcile the Balance "variant" API with Workflow's colour requirements. */
export const Tag = forwardRef<HTMLDivElement, TagProps>(
  ({ color = defaultColor, ...tagProps }, forwardedRef) => {
    const variant = useMemo(() => workflowPaletteKeys.indexOf(color), [color]);

    return <BalanceTag variant={variant} ref={forwardedRef} {...tagProps} />;
  }
);

Tag.displayName = 'Tag';
